
import { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { getAdminAuth, clearAdminAuth } from "../admin/adminStorage";
import { adminApi } from "../admin/api";

export default function AdminRoute() {
  const location = useLocation();

  const [status, setStatus] = useState("checking");

  useEffect(() => {
    let active = true;

    const verifyAuthentication = async () => {
      const auth = getAdminAuth();

      if (!auth?.token) {
        if (active) setStatus("unauthenticated");
        return;
      }

      try {
        await adminApi.verifyToken(auth.token);

        if (active) {
          setStatus("authenticated");
        }
      } catch (error) {
        clearAdminAuth();

        if (active) {
          setStatus("unauthenticated");
        }
      }
    };

    verifyAuthentication();

    return () => {
      active = false;
    };
  }, []);

  if (status === "checking") {
    return (
      <div className="admin-auth-loading">
        Verifying authentication...
      </div>
    );
  }

  if (status === "unauthenticated") {
    return (
      <Navigate
        to="/admin/login"
        replace
        state={{ from: location }}
      />
    );
  }

  return <Outlet />;
}
